import { Injectable } from '@angular/core';
import { httpResource } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AppConfig } from '../../models/app-config.model';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  configResource = httpResource<AppConfig>(() => `${API_URL}/configs/app`);
}
